<div class="flex w-full justify-end">
  <aw-language-switcher
    id="language-switcher"
    [formControl]="language"></aw-language-switcher>
</div>
@if (isLoading()) {
  <aw-loading-animation></aw-loading-animation>
}
<aw-section testIdAffix="section">
  @if (tileForm && section() && !isLoading()) {
    <div class="flex flex-col gap-4">
      <div class="flex justify-between pb-3">
        <aw-section-headline class="font-bold">
          {{ cmsTextProvider.customTiles.editTile }}
        </aw-section-headline>
        @let hasChanges = hasUnsavedChanges(tileForm);
        <div class="flex gap-2">
          <aw-button
            [text]="cmsTextProvider.shared.save"
            [isDisabled]="!tileForm.valid || !hasChanges"
            [type]="'button'"
            (click)="saveTile()"
            id="save-card"></aw-button>
          <aw-button
            [style]="'error-alt'"
            [isDisabled]="!hasChanges"
            [text]="cmsTextProvider.shared.cancel"
            (click)="handleAbortChangesDialog()"
            [type]="'button'"
            id="cancel-card-edit">
          </aw-button>
        </div>
      </div>

      <div class="flex flex-row">
        <aw-toggle
          (valueChange)="correctDateValues($event)"
          [formControl]="tileForm.controls.isActive"
          [showLabelLeft]="true"
          [id]="'isActive'"
          [label]="cmsTextProvider.customTiles.setTileActive">
        </aw-toggle>
        @if (tileForm.controls.isActive.value) {
          <div class="flex min-w-2/3 flex-row gap-4">
            <aw-date-input
              [formControl]="tileForm.controls.startDate"
              id="ticket-start"
              label="Ab"></aw-date-input>
            <aw-date-input
              [formControl]="tileForm.controls.endDate"
              id="ticket-end"
              label="Bis (optional)"></aw-date-input>
          </div>
        }
      </div>
      <div class="text-2xl font-semibold">
        {{ cmsTextProvider.shared.image }}
      </div>
      <div class="flex flex-row gap-4">
        <aw-image-select
          id="tile-image"
          [label]="cmsTextProvider.shared.image"
          [usageLabel]="'customTile.image'"
          [persistUsageOnSelect]="true"
          [formControl]="
            tileForm.controls.accessibleImage.controls.image
          "></aw-image-select>
        <aw-translation-accessibility-text-input
          id="tile-image-alt-text"
          [label]="cmsTextProvider.shared.description"
          [entityType]="EEntityType.customTile"
          [relationType]="ERelationType.imageAlt"
          [formControl]="
            tileForm.controls.accessibleImage.controls.imageAlts
          "></aw-translation-accessibility-text-input>
      </div>
      <div class="text-2xl font-semibold">
        {{ cmsTextProvider.shared.text }}
      </div>
      <aw-translation-text-input
        id="tile-title"
        [label]="cmsTextProvider.shared.title"
        [entityType]="EEntityType.customTile"
        [relationType]="ERelationType.title"
        [formControl]="tileForm.controls.title"></aw-translation-text-input>
      <aw-translation-text-editor
        id="tile-text"
        [label]="cmsTextProvider.shared.description"
        [entityType]="EEntityType.customTile"
        [relationType]="ERelationType.descriptionText"
        [formControl]="
          tileForm.controls.description
        "></aw-translation-text-editor>
      <div class="text-2xl font-semibold">
        {{ cmsTextProvider.shared.link }}
      </div>
      <aw-translation-text-input
        id="link-text"
        [label]="cmsTextProvider.customTiles.linkText"
        [entityType]="EEntityType.customTile"
        [relationType]="ERelationType.iconText"
        [formControl]="tileForm.controls.linkText"></aw-translation-text-input>
      <aw-text-input
        id="link-url"
        [label]="cmsTextProvider.customTiles.linkAddress"
        [formControl]="tileForm.controls.link"></aw-text-input>
    </div>
  }
</aw-section>
